import React from 'react';

import ShippingMethodChooser from 'components/account/Returns/ShippingMethodChooser';
import ShippingMethodChooserWithInstructions from 'components/account/Returns/ShippingMethodChooserWithInstructions';
import UPSBanner from 'components/account/UPSBanner';
import returnsUtils from 'utils/returns';
import { cn } from 'helpers/classnames';

import css from 'styles/components/account/returns/returnShippingHandler.scss';

export const ReturnShippingHandler = ({
  marketplace,
  labelDelivery,
  UPSPickUpAddress,
  onLabelDeliverySelect,
  onCancelReturn,
  onSubmitReturn,
  isStoreCreditEnabled,
  labelPaymentType,
  zeroOriginalPaymentBalance,
  afterPayOrder,
  ...props
}) => {
  const {
    account,
    returns,
    shipping,
    updateMailingAddressOrName,
    updateShippingPhone,
    akitaPickup,
    shipmentOptions,
    isShipmentOptionsLoading,
    showAvailableReturnLabels,
    arePickupReturnsAuthorized,
    showPackagelessReturn
  } = props;
  const { customerInfo } = account;
  const {
    isPrivateLabel,
    returns: { showMailedLabelOption, showLabellessReturns, showReturnInstructionsBoxes, showPackagelessInVertical }
  } = marketplace;

  return (
    <>
      {showReturnInstructionsBoxes ? (
        <>
          <div className={css.returnItemInstructionTitle}>
            <h2 className="zappos:heading-s">How would you like to return your items?</h2>
          </div>
          <ShippingMethodChooserWithInstructions
            hasMultiItems={returnsUtils.hasMultiItemsForReturn(returns)}
            shipping={shipping}
            isStoreCreditEnabled={isStoreCreditEnabled}
            labelPaymentType={labelPaymentType}
            zeroOriginalPaymentBalance={zeroOriginalPaymentBalance}
            afterPayOrder={afterPayOrder}
            labelDelivery={labelDelivery}
            UPSPickUpAddress={UPSPickUpAddress}
            showMailedLabelOption={showMailedLabelOption}
            showLabellessReturns={showLabellessReturns}
            options={shipmentOptions}
            isLoading={isShipmentOptionsLoading}
            showAvailableReturnLabels={showAvailableReturnLabels}
            showPackagelessReturn={showPackagelessInVertical && showPackagelessReturn}
            arePickupReturnsAuthorized={returnsUtils.shouldAuthorizePickups(arePickupReturnsAuthorized, akitaPickup, returns)}
            onLabelDeliverySelect={onLabelDeliverySelect}
            onCancelReturn={onCancelReturn}
            onSubmitReturn={onSubmitReturn}
            onUpdateMailingAddressOrName={updateMailingAddressOrName}
            onUpdateShippingPhone={updateShippingPhone}
            customerInfo={customerInfo}
          />
        </>
      ) : (
        <>
          <div className={css.upsLogoAndTitle}>
            <UPSBanner />
            <div className={cn(css.returnItemInstructionTitle, 'zappos:body-m')}>
              {isPrivateLabel ? (
                <p>We provide shipping labels using UPS for easy, fast, and secure shipping and package tracking.</p>
              ) : (
                <h2>How to Return Your Item(s)</h2>
              )}
            </div>
          </div>
          {isPrivateLabel && <p className={cn(css.privateLabelHeader, 'zappos:body-m')}>How would you like to receive your label?</p>}
          <ShippingMethodChooser
            shipping={shipping}
            labelDelivery={labelDelivery}
            UPSPickUpAddress={UPSPickUpAddress}
            showMailedLabelOption={showMailedLabelOption}
            showLabellessReturns={showLabellessReturns}
            options={shipmentOptions}
            isStoreCreditEnabled={isStoreCreditEnabled}
            labelPaymentType={labelPaymentType}
            zeroOriginalPaymentBalance={zeroOriginalPaymentBalance}
            afterPayOrder={afterPayOrder}
            isLoading={isShipmentOptionsLoading}
            showAvailableReturnLabels={showAvailableReturnLabels}
            arePickupReturnsAuthorized={returnsUtils.shouldAuthorizePickups(arePickupReturnsAuthorized, akitaPickup, returns)}
            onLabelDeliverySelect={onLabelDeliverySelect}
            onCancelReturn={onCancelReturn}
            onSubmitReturn={onSubmitReturn}
            onUpdateMailingAddressOrName={updateMailingAddressOrName}
            onUpdateShippingPhone={updateShippingPhone}
            isPrivateLabel={isPrivateLabel}
          />
        </>
      )}
    </>
  );
};
